"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Wordmark } from "./wordmark";
import styles from "./app-header.module.css";

// The welcome and sign-in screens carry their own wordmark and fill the viewport,
// so the app bar would only repeat itself there.
const BARE = ["/welcome", "/signin"];

export function AppHeader() {
  const path = usePathname();
  if (BARE.some((p) => path.startsWith(p))) return null;

  return (
    <header className={styles.head}>
      <div className="awning" aria-hidden="true" />
      <div className={styles.bar}>
        <Link href="/" className={styles.brand}><Wordmark /></Link>
        <Link href="/questions" className={styles.help}>What is this?</Link>
      </div>
    </header>
  );
}
